import { useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// import { useLoadAuthUser } from '../../../hooks/authhooks';
// import LoadingScreen from "../../shared/LoadingScreen";
import homecook_logo from '../../../assets/img/homecook_logo.png'
import { SelfServiceDetailsSchema } from '../../../data/types';

import SelfServiceRegistrationForm from '../../../molecules/forms/SelfServiceRegistrationForm';
import { useSelfServices } from '../../../hooks/communityhook';
// import { useAuthState } from '../../../contexts/authcontext'
// import SelfServiceAdmin from './SelfServiceAdmin';
// Sample companies data - in a real app, this would come from an API
// export const COMPANIES = [
//   { id: '1', name: 'Amerigroup', boothNumber: 'A1' },
//   { id: '2', name: 'BCFSN', boothNumber: 'A2' },
//   { id: '3', name: 'CM Felder', boothNumber: 'A3' },
//   { id: '4', name: 'DC Gov\'t', boothNumber: 'A4' },
//   { id: '5', name: 'DPR Environmental Division', boothNumber: 'A5' },
//   { id: '6', name: 'Children\'s National', boothNumber: 'B1' },
//   { id: '7', name: 'East River Collaborative', boothNumber: 'B2' },
//   { id: '8', name: 'Earth Conservation Corp', boothNumber: 'B3' },
//   { id: '9', name: 'DC Central Kitchen', boothNumber: 'B4' },
//   { id: '10', name: 'The Links', boothNumber: 'B5' },
//   { id: '11', name: 'Common Good City Farms', boothNumber: 'C1' },
//   { id: '12', name: 'EOM / DC Food Policy / Office of Planning', boothNumber: 'C2' },
//   { id: '13', name: 'DC Legal Aid', boothNumber: 'C3' },
//   { id: '14', name: 'HomeCook', boothNumber: 'C4' },
//   { id: '15', name: 'SWAP DC', boothNumber: 'C5' }
// ];
// const SIGN_IN_METHODS = [
//   { id: 'email', label: 'Email' },
//   { id: 'phone', label: 'Phone Number' }
// ];



// interface SelfServiceDetailsMap {
//   [key: string]: SelfServiceDetailsSchema;
// }

// // Event details mapping
// const EVENT_DETAILS: SelfServiceDetailsMap = {
//   'springfest': {
//     id: 'springfest',
//     name: 'SpringFest 2025',
//     logo: 'https://dreamingoutloud.org/wp-content/uploads/2024/10/Dreaming-Out-Loud-Home-Logo-.webp',
//     organizer: 'Dreaming Out Loud',
//     organizer_url: 'https://dreamingoutloud.org',
//     date: 'April 15, 2025',
//     start_time: '10:00 AM',
//     end_time: '6:00 PM'
//   },
//   'summerfest': {
//     id: 'summerfest',
//     name: 'SummerFest 2025',
//     logo: 'https://dccentralkitchen.org/wp-content/uploads/2022/03/DCCentralKitchen_logo-hi-res-75x75.png',
//     organizer: 'DC Central Kitchen',
//     organizer_url: 'https://dccentralkitchen.org/',
//     date: 'July 20, 2025',
//     start_time: '9:00 AM',
//     end_time: '5:00 PM'
//   },
//   // Add more events as needed
// };





const LoggedOutSelfServiceRegistration = () => {
//   const { isloggedin } = useAuthState()
  // const navigate = useNavigate();
  const { event } = useParams();
  // const { registerBusiness, isLoading } = useLoadAuthUser();

  // const [error, setError] = useState('');
  // const [lookupData, setLookupData] = useState({
  //   searchTerm: '',
  //   searchType: 'name' // 'name' or 'email'
  // });
  // const [searchResults, setSearchResults] = useState<any[]>([]);
  // const [registeredUsers, setRegisteredUsers] = useState<any[]>([]);
  // const [showRegisteredUsers, setShowRegisteredUsers] = useState(false);
  // const [showSearchResults, setShowSearchResults] = useState(false);
  // const [isSearchResultsCollapsed, setIsSearchResultsCollapsed] = useState(false);
  // const [isRegisteredUsersCollapsed, setIsRegisteredUsersCollapsed] = useState(false);
  // const [showEventManagement, setShowEventManagement] = useState(false);
  // const [isEventManagementCollapsed, setIsEventManagementCollapsed] = useState(false);
  // const [eventFormData, setEventFormData] = useState({
  //   name: '',
  //   code: '',
  //   logo: '',
  //   organizer: '',
  //   organizerUrl: '',
  //   date: '',
  //   startTime: '',
  //   endTime: '',
  //   isEditing: false
  // });


  // const handleEventSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   // TODO: Implement actual API call for event creation/update
  //   // const newEvent = {
  //   //   [eventFormData.code.toLowerCase()]: {
  //   //     name: eventFormData.name,
  //   //     logo: eventFormData.logo,
  //   //     organizer: eventFormData.organizer,
  //   //     organizerUrl: eventFormData.organizerUrl
  //   //   }
  //   // };

  //   // For now, just show a success message
  //   alert(`Event ${eventFormData.isEditing ? 'updated' : 'created'} successfully!`);
  //   setEventFormData({
  //     name: '',
  //     code: '',
  //     logo: '',
  //     organizer: '',
  //     organizerUrl: '',
  //     date: '',
  //     startTime: '',
  //     endTime: '',
  //     isEditing: false
  //   });
  // };
  // const [activeTab, setActiveTab] = useState<'lookup' | 'registered' | 'form'>('form');
  const navigate = useNavigate();

  const [error, setError] = useState<string>('');

  const [eventCode, setEventCode] = useState<string>(event || '');

  const { selfServices, isLoadingSelfServices, isErrorSelfServices, reloadSelfServices } = useSelfServices();

  // Get self service details based on event code, return null if not found
  const selfServiceDetails = useMemo(() => {
    if (!selfServices) return {} as SelfServiceDetailsSchema;
    return event ? selfServices[event.toLowerCase()] || {} as SelfServiceDetailsSchema : {} as SelfServiceDetailsSchema;
  }, [event, selfServices]);





  // const handleEventCodeSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const trimmedCode = formData.eventCode.trim();
    
  //   if (!trimmedCode) {
  //     setError('Please enter an event code');
  //     return;
  //   }

  //   if (trimmedCode.length < 3) {
  //     setError('Event code must be at least 3 characters long');
  //     return;
  //   }

  //   if (!EVENT_DETAILS[trimmedCode.toLowerCase()]) {
  //     setError('Invalid event code. Please check and try again.');
  //     return;
  //   }

  //   navigate(`/self-service/${trimmedCode}`);
  // };

  // const handleLookup = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   // TODO: Implement actual API call for lookup
  //   // For now, using mock data
  //   const mockResults = [
  //     { id: '1', name: 'John Doe', email: 'john@example.com', phone: '123-456-7890' },
  //     { id: '2', name: 'Jane Smith', email: 'jane@example.com', phone: '987-654-3210' }
  //   ];
  //   // setSearchResults(mockResults);
  //   // setShowSearchResults(true);
  //   // setIsSearchResultsCollapsed(false);
  // };

  // const handleViewRegisteredUsers = async () => {
  //   // TODO: Implement actual API call to fetch registered users
  //   // For now, using mock data
  //   const mockUsers = [
  //     { id: '1', name: 'John Doe', email: 'john@example.com', company: 'TechCorp', booth: 'A1' },
  //     { id: '2', name: 'Jane Smith', email: 'jane@example.com', company: 'InnovateX', booth: 'B2' }
  //   ];
  //   // setRegisteredUsers(mockUsers);
  //   // setShowRegisteredUsers(true);
  //   // setIsRegisteredUsersCollapsed(false);
  // };

  // const handleEditEvent = (eventCode: string) => {
  //   const eventDetails = EVENT_DETAILS[eventCode.toLowerCase()];
  //   if (eventDetails) {
  //     setEventFormData({
  //       name: eventDetails.name,
  //       code: eventCode,
  //       logo: eventDetails.logo || '',
  //       organizer: eventDetails.organizer,
  //       organizerUrl: eventDetails.organizerUrl,
  //       date: eventDetails.date,
  //       startTime: eventDetails.startTime,
  //       endTime: eventDetails.endTime,
  //       isEditing: true
  //     });
  //     // setShowEventManagement(true);
  //     // setIsEventManagementCollapsed(false);
  //   }
  // };

  // const handleEventCodeClick = (eventCode: string) => {
  //   navigate(`/self-service/${eventCode}`);
  // };


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setEventCode(e.target.value);
  };

  const handleEventCodeSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    reloadSelfServices();
    const trimmedCode = eventCode.trim();
    
    if (!trimmedCode) {
      setError('Please enter an event code');
      return;
    }

    if (trimmedCode.length < 3) {
      setError('Event code must be at least 3 characters long');
      return;
    }

    if (!selfServices[trimmedCode.toLowerCase()]) {
      setError('Invalid event code. Please check and try again.');
      return;
    }

    navigate(`/self-service/${trimmedCode}`);
  };


  useEffect(() => {
    if (event && !eventCode) {
      setEventCode(event);
      setError('');
    }
    window.document.title = `${selfServiceDetails?.name || 'HomeCook'} | Registration`;
  }, [event, eventCode, selfServiceDetails]);



  return (
    <div className={`min-h-screen bg-back-500 flex flex-col justify-start py-12 px-4 sm:px-6 lg:px-8`}>
      <div className="w-full max-w-2xl mx-auto">
        {isLoadingSelfServices ? (
          <div className="text-center">
            <p className="text-primary-200">Loading...</p>
          </div>
        ) : isErrorSelfServices ? (
          <div className="text-center text-red-500">
            <p>Error loading event details. Please try again later.</p>
          </div>
        ) : (
          <>
            {/* Event Partner Branding */}
            <div className="text-center mb-8">
              <div className="flex justify-center items-center space-x-4">
                {(selfServiceDetails?.id) ? (
                  <>
                    <img
                      className="h-16 w-auto"
                      src={selfServiceDetails.logo || homecook_logo}
                      alt={`${selfServiceDetails.organizer} Logo`}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = homecook_logo;
                      }}
                    />
                    <div className="text-left">
                      <h1 className="text-2xl font-bold text-primary-200 font-raleway">{selfServiceDetails.name}</h1>
                      <p className="text-[10px] text-back-200 font-open-sans">
                        Powered by <a className="text-primary-300 hover:text-primary-400 transition-colors" href="https://homecookapp.com" target="_blank" rel="noopener noreferrer">HomeCook</a>
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      className="h-16 w-auto"
                      src={homecook_logo}
                      alt="HomeCook Logo"
                    />
                    {/* <div className="text-left">
                      <h1 className="text-2xl font-bold text-primary-200 font-raleway">Venue Sign In | Registration</h1>
                      <p className="text-[10px] text-back-200 font-open-sans">Powered by <a className="text-primary-300 hover:text-primary-400 transition-colors" href="https://homecookapp.com" target="_blank" rel="noopener noreferrer">HomeCook</a></p>
                    </div> */}
                  </>
                )}
              </div>
            </div>

            {/* Enter Access Code Section - Only for non-logged-in users */}
            {(!eventCode || !selfServiceDetails?.id) ? (
              <>
              <div className="bg-white py-8 px-6 shadow-lg rounded-xl sm:px-10">
                <div className="mb-8">
                  <h2 className="text-center text-2xl font-bold text-primary-200 font-raleway">
                    Self Service Registration
                  </h2>
                  <p className="mt-2 text-center text-sm text-back-200 font-open-sans">
                    Please enter your access code to begin
                  </p>
                </div>
                <form onSubmit={handleEventCodeSubmit} className="space-y-6">
                  <div>
                    <input
                      type="text"
                      name="eventCode"
                      value={eventCode}
                      onChange={(e) => {
                        setError('');
                        handleChange(e);
                      }}
                      className={`mt-1 font-open-sans block w-full border ${
                        error ? 'border-red-300' : 'border-back-400'
                      } rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300`}
                      placeholder="Enter access code"
                      required
                    />
                    {error && (
                      <div className="mt-2 flex items-center text-sm text-red-600">
                        <svg className="h-4 w-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                        {error}
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="w-full font-bold font-open-sans flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-md text-white bg-primary-300 hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-300 transition-colors"
                    >
                      Continue
                    </button>
                  </div>
                </form>
              </div>
              {
                (eventCode) && (
                  <div className="mt-8 text-center">
                    <div className="bg-white py-8 px-6 shadow-lg rounded-xl sm:px-10">
                      <div className="flex flex-col justify-center items-center bg-red-100 p-4 rounded-md">
                        <h2 className="text-md font-semibold text-red-900 font-raleway mb-2">
                          Invalid Access Code
                        </h2>
                        <p className="text-red-300 text-sm font-open-sans mb-2">
                          The code you entered either doesn't exist or is invalid.
                        </p>
                        <p className="text-xs text-gray-400 font-open-sans">
                          Please check the access code and try again, or contact support for assistance.
                        </p>
                      </div>
                    </div>
                  </div>
                )
              }
              </>
            ) : (
              <>
                <h2 className="mt-6 text-center text-xl font-semibold text-primary-200 font-raleway">
                  Self-Service Registration
                </h2>
                <p className="mt-2 text-center text-sm text-back-200 font-open-sans">
                  Complete your registration to access {selfServiceDetails?.name || 'the event'}
                </p>

                {/* Registration Form - Visible for all users */}
                <div className="mt-8 w-full max-w-2xl mx-auto">
                  <div className="bg-white py-8 px-6 shadow-lg rounded-xl sm:px-10">
                    <SelfServiceRegistrationForm selfServiceDetails={selfServiceDetails} />
                  </div>
                </div>

              </>
            )}
          </>
        )}
      </div>
    </div>
  );

};



export default LoggedOutSelfServiceRegistration; 